import React from 'react';
import PropTypes from 'prop-types';

import { I18n } from 'Locales';
import { mockFunction } from 'Helpers';
import { MODAL_SIZES } from 'Constants';
import { Button, Modal } from 'Components';

import './style.scss';
import { ErrorsModal, ReonboardModal, WelcomeEmailModal } from './subviews';

const handleSendWelcomeEmail = ({
  custom_footer = '',
  email = '',
  selectedRows = [],
  sendWelcomeEmail = mockFunction,
  updateTransientProps = mockFunction
}) => {
  updateTransientProps({
    custom_footer: '',
    errorsModal: false,
    profilesWithErrors: [],
    profilesWithoutErrors: '',
    selectedRows: [],
    showWelcomeEmailModal: false
  });

  sendWelcomeEmail({ custom_footer, email, rows: selectedRows, bulk: true });
};

const BulkModal = ({
  allCampaignsHaveSystemBadges = false,
  campaigns = [],
  clients = [],
  custom_footer = '',
  email = '',
  email_error_message = [],
  email_has_error = false,
  errorsModal = false,
  getCampaignsByClient = mockFunction,
  isOneRowSelected = '',
  profilesWithErrors = [],
  profilesWithoutErrors = '',
  reOnboard = mockFunction,
  reOnboardLoading = false,
  selected_client = '',
  selected_signer = '',
  selectedCampaigns = [],
  selectedRows = [],
  sendWelcomeEmail = mockFunction,
  showReonboardModal = false,
  showWelcomeEmailModal = false,
  signers = [],
  updateTransientProps = mockFunction,
  updateTransientPropWithValidations = mockFunction
}) => {
  let modalTitle = '';

  if (errorsModal) modalTitle = I18n.t('admin:bulkErrors.actionSummary');
  if (showReonboardModal) modalTitle = I18n.t('admin:reOnboardModal.reOnboardBA');
  if (showWelcomeEmailModal) modalTitle = I18n.t('admin:welcomeEmailModal.sendWelcomeEmail');

  return (
    <Modal
      id={'modal'}
      open={errorsModal || showWelcomeEmailModal || showReonboardModal}
      size={MODAL_SIZES.MEDIUM}
      onClose={updateTransientProps.bind(null, {
        email_error_message: '',
        email_has_error: false,
        email: '',
        errorsModal: false,
        profilesWithErrors: [],
        profilesWithoutErrors: '',
        selectedCampaigns: [],
        selected_client: '',
        selected_signer: '',
        selectedRows: [],
        showWelcomeEmailModal: false,
        showReonboardModal: false
      })}>
      <Modal.Title>
        <div className="title-md font-bold">{modalTitle}</div>
      </Modal.Title>

      <Modal.Content>
        {showWelcomeEmailModal ? (
          <WelcomeEmailModal
            custom_footer={custom_footer}
            email_error_message={email_error_message}
            email_has_error={email_has_error}
            email={email}
            isOneRowSelected={isOneRowSelected}
            selectedRows={selectedRows}
            updateTransientProps={updateTransientProps}
            updateTransientPropWithValidations={updateTransientPropWithValidations}
          />
        ) : showReonboardModal ? (
          <ReonboardModal
            campaigns={campaigns}
            clients={clients}
            getCampaignsByClient={getCampaignsByClient}
            selected_client={selected_client}
            selectedRows={selectedRows}
            signers={signers}
            updateTransientProps={updateTransientProps}
          />
        ) : (
          <ErrorsModal profilesWithErrors={profilesWithErrors} profilesWithoutErrors={profilesWithoutErrors} />
        )}
      </Modal.Content>

      <Modal.Actions>
        {(showWelcomeEmailModal || showReonboardModal) && (
          <Button.OutlineSmall
            onClick={updateTransientProps.bind(null, {
              email_error_message: '',
              email_has_error: false,
              email: '',
              errorsModal: false,
              profilesWithErrors: [],
              profilesWithoutErrors: '',
              selectedCampaigns: [],
              selected_client: '',
              selected_signer: '',
              selectedRows: [],
              showWelcomeEmailModal: false,
              showReonboardModal: false
            })}>
            {I18n.t('general:cancel')}
          </Button.OutlineSmall>
        )}

        <Button.PrimarySmall
          disabled={showReonboardModal ? !(selectedCampaigns?.length && selected_client && selected_signer) : false}
          processing={reOnboardLoading}
          onClick={
            showWelcomeEmailModal
              ? handleSendWelcomeEmail.bind(null, {
                  custom_footer,
                  email,
                  selectedRows,
                  sendWelcomeEmail,
                  updateTransientProps
                })
              : showReonboardModal
              ? reOnboard.bind(null, {
                  allCampaignsHaveSystemBadges,
                  selectedCampaigns,
                  selected_client,
                  selected_signer,
                  selectedRows
                })
              : updateTransientProps.bind(null, {
                  email_error_message: '',
                  email_has_error: false,
                  email: '',
                  errorsModal: false,
                  profilesWithErrors: [],
                  profilesWithoutErrors: '',
                  selectedCampaigns: [],
                  selected_client: '',
                  selected_signer: '',
                  selectedRows: [],
                  showReonboardModal: false,
                  showWelcomeEmailModal: false
                })
          }>
          {showWelcomeEmailModal
            ? I18n.t('general:send')
            : showReonboardModal
            ? I18n.t('general:save')
            : I18n.t('general:ok')}
        </Button.PrimarySmall>
      </Modal.Actions>
    </Modal>
  );
};

BulkModal.propTypes = {
  allCampaignsHaveSystemBadges: PropTypes.bool,
  campaigns: PropTypes.array,
  clients: PropTypes.array,
  custom_footer: PropTypes.string,
  email_error_message: PropTypes.string,
  email_has_error: PropTypes.bool,
  email: PropTypes.string,
  errorsModal: PropTypes.bool,
  getCampaignsByClient: PropTypes.func,
  isOneRowSelected: PropTypes.bool,
  profilesWithErrors: PropTypes.array,
  profilesWithoutErrors: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  reOnboard: PropTypes.func,
  reOnboardLoading: PropTypes.bool,
  reuse_existing_badge_number: PropTypes.bool,
  selected_client: PropTypes.string,
  selected_signer: PropTypes.string,
  selectedCampaigns: PropTypes.array,
  selectedRows: PropTypes.array,
  sendWelcomeEmail: PropTypes.func,
  showReonboardModal: PropTypes.bool,
  showWelcomeEmailModal: PropTypes.bool,
  signers: PropTypes.array,
  updateTransientProps: PropTypes.func,
  updateTransientPropWithValidations: PropTypes.func,
  user: PropTypes.object
};

export default BulkModal;
